import CircleIcon from '@mui/icons-material/Circle';
import Box from '@mui/material/Box';
import { useContext } from 'react';

import { ApplicationContext } from '../../../../../shared/source/context/context';

import type { FunctionComponent } from 'react';

export const SkillsBarChartDataGridHeader: FunctionComponent<{ readonly withLearningOpportunities: boolean }> = ({
    withLearningOpportunities,
}) => {
    const { translate } = useContext(ApplicationContext);

    return (
        <Box sx={{ display: 'flex', width: '100%' }}>
            <Box
                sx={{
                    flex: 1,
                }}
            >
                <CircleIcon fontSize="small" sx={{ color: 'user.main', marginRight: '8px', verticalAlign: '-5px' }} />
                {translate('pages.global-search.headlines.employees')}
            </Box>
            <Box
                sx={{
                    flex: 1,
                }}
            >
                <CircleIcon
                    fontSize="small"
                    sx={{ color: 'jobposting.main', marginRight: '8px', verticalAlign: '-5px' }}
                />
                {translate('pages.global-search.headlines.jobs')}
            </Box>
            {withLearningOpportunities && (
                <Box
                    sx={{
                        flex: 1,
                    }}
                >
                    <CircleIcon
                        fontSize="small"
                        sx={{
                            color: 'learningOpportunity.main',
                            marginRight: '8px',
                            verticalAlign: '-5px',
                        }}
                    />
                    {translate('pages.global-search.headlines.learning-opportunities')}
                </Box>
            )}
        </Box>
    );
};
